module.exports = __webpack_public_path__ + "assets/virtualClassroom-desktop.845fc32c3e0fc6486b8969fc71061f62.png";